module.exports = __webpack_public_path__ + "assets/img/template_banner_bg.da63ed23.png";